import React from 'react';
import { connect } from 'react-redux';
import { DetailSectionModularProps, mapDispatchToProps, mapStateToProps } from 'component/page/detail/DetailCard/DetailsCard.selectors';
import { TitleSectionVariant } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import DetailTitleNoThumbnail from 'component/page/detail/DetailCard/DetailTitleNoThumbnail';
import DetailTitleWithThumbnail from 'component/page/detail/DetailCard/DetailTitleWithThumbnail';

const DetailTitleSectionModular: React.FC<DetailSectionModularProps> = React.memo((props) => {
    if (props.variant === TitleSectionVariant.NoThumbnail) {
        return <DetailTitleNoThumbnail variant={props.variant} />;
    }

    return <DetailTitleWithThumbnail variant={TitleSectionVariant.WithThumbnail} />;
});

DetailTitleSectionModular.displayName = 'DetailCard';

export default connect(mapStateToProps, mapDispatchToProps)(DetailTitleSectionModular);
